<template>
    <hh-accent-panel class="attributions-panel">
        <h3>{{ myResources.title }}</h3>
        <p>{{ myResources.introText }}</p>
        <p><a class="attributions-panel__link" @click="onAttributionsClick">{{ myResources.linkText }}</a></p>
    </hh-accent-panel>
</template>

<script>

import AttributionsHelper from '@/components/attributions-helper'
import ResourcesHelper from '@/components/resources-helper'

export default {
    mixins: [
        AttributionsHelper,
        ResourcesHelper,
    ],

    computed: {
        /**
         * @returns {AppCoreAttributionsPanelResources}
         */
        myResources() {
            return this.parseResources('components.appCore.attributionsPanel')
        },
    },
}

</script>

<style lang="scss">

.attributions-panel {
    margin-top: 3rem;

    @include bp-min-wide {
        margin-top: 0;
    }

    h3 {
        font-size: 20px;
        font-weight: 500;
        letter-spacing: 0.25px;
        line-height: 24px;
    }

    a {
        cursor: pointer;
    }

    p:last-child {
        margin-bottom: 0;
    }
}

</style>
